export enum VIDEO_INTERVIEW_QUESTION_STATUS {
  STARTED = 'Started',
  FINISHED = 'Finished',
}
